import { app } from "@/config"
import _ from "lodash";

/**
 * Just like the asset helper in blade this will do the same trick
 *
 * @param asset_path
 * @returns {string}
 */
export const asset = asset_path => app.url + asset_path;

/**
 * A quick pattern to segregate the value and the unit from an human size string
 *
 * example: 30MB = [30, 'MB']
 * @type {RegExp}
 */
export const sizePattern = /([0-9]+)\S?([A-Z]{2})/i;

/**
 * A map structure for conversions sequence
 * @type {{MB: string, KB: string, GB: string, TB: string}}
 */
export const sizeMapUnits = {
    KB: 'B',
    MB: 'KB',
    GB: 'MB',
    TB: 'GB',
};

/**
 * Converts a human size value into a bytes size values
 *
 * @param {string|number} size
 * @returns {number}
 */
export const toRealSize = size => {
    let unit;
    [, size, unit] = size.match(sizePattern);

    while (unit !== 'B'){
        size *= 1024;
        unit = sizeMapUnits[unit];
    }

    return parseInt(size);
}

/**
 * Converts a bytes size value into a human size value
 *
 * @param size
 * @returns {`${number}B`}
 */
export const toHumanSize = size => {
    const reverseMapUnits = _.invert(sizeMapUnits);
    let unit = 'B';

    while(size > 1024){
        size /= 1024;

        unit = reverseMapUnits[unit];
    }

    size = Math.floor(parseFloat(size));

    return `${size}${unit}`;
}
